import React from 'react';
import { motion } from 'framer-motion';
import { MapIcon, CoinsIcon, EyeOffIcon, LineChartIcon } from 'lucide-react';
import { OrnateDivider } from './Dividers';
const problems = [{
  icon: <MapIcon className="w-8 h-8" data-id="element-152" />,
  title: 'Scattered Realms',
  description: 'Fantasy content creators struggle with fragmented distribution across dozens of platforms with no unified strategy, leaving audiences divided and engagement diluted.'
}, {
  icon: <CoinsIcon className="w-8 h-8" data-id="element-153" />,
  title: 'The Monetization Void',
  description: 'Niche entertainment content is chronically undervalued by mainstream ad networks that fail to comprehend the deep loyalty and purchasing power of fantasy audiences.'
}, {
  icon: <EyeOffIcon className="w-8 h-8" data-id="element-154" />,
  title: 'Lost in the Noise',
  description: 'Without targeted syndication, quality fantasy content drowns among generic entertainment, never reaching the true audience that craves your specific lore.'
}, {
  icon: <LineChartIcon className="w-8 h-8" data-id="element-155" />,
  title: 'The Measurement Abyss',
  description: 'Creators and publishers lack analytics tailored to fantasy engagement patterns, navigating blindly without understanding cross-platform attribution.'
}];
export const Problems = () => {
  return <section id="syndication" className="py-24 bg-burgundy-900 relative texture-overlay" data-id="element-156">
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-157">
        <div className="text-center mb-16" data-id="element-158">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-display text-4xl md:text-5xl text-gold-500 mb-4" data-id="element-159">
            The Trials of the Unseen
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-xl text-parchment-200 max-w-2xl mx-auto" data-id="element-160">
            The path of the chronicler is fraught with peril. Many great tales
            remain untold, lost to the void of the modern web.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-161">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1 + 0.3
        }} className="bg-parchment-100 p-8 border-ornate text-burgundy-950 shadow-xl relative group overflow-hidden" data-id="element-162">
              {/* Subtle texture over the card */}
              <div className="absolute inset-0 bg-[url('data:image/svg+xml,%3Csvg viewBox=%220 0 200 200%22 xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cfilter id=%22noise%22%3E%3CfeTurbulence type=%22fractalNoise%22 baseFrequency=%220.8%22 numOctaves=%223%22 stitchTiles=%22stitch%22/%3E%3C/filter%3E%3Crect width=%22100%25%22 height=%22100%25%22 filter=%22url(%23noise)%22 opacity=%220.05%22/%3E%3C/svg%3E')] pointer-events-none" data-id="element-163"></div>

              <div className="relative z-10" data-id="element-164">
                <div className="w-16 h-16 bg-burgundy-900 text-gold-500 flex items-center justify-center rounded-sm mb-6 border border-burgundy-800 shadow-inner" data-id="element-165">
                  {problem.icon}
                </div>
                <h3 className="font-heading text-2xl font-bold mb-4 text-burgundy-900 border-b border-burgundy-900/20 pb-2 inline-block" data-id="element-166">
                  {problem.title}
                </h3>
                <p className="text-lg leading-relaxed text-burgundy-800 font-medium" data-id="element-167">
                  {problem.description}
                </p>
              </div>
            </motion.div>)}
        </div>

        <OrnateDivider className="mt-20" data-id="element-168" />
      </div>
    </section>;
};